// @ts-nocheck
/* eslint-disable */
export const appIconArrowUp12Icon = {
    data: `<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 12 12" xml:space="preserve"><path stroke-linecap="round" fill="none" stroke="currentColor" d="M6,10V2.6"/><path stroke-linecap="round" fill="none" stroke="currentColor" d="M9.5,5.6L6,2L2.5,5.6"/></svg>`,
    name: 'icon-arrow-up-12' as const
};